<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/studies">Accueil</a></li>
                <li>Suivi des cours</li>
            </ul>
            <h2 style="color:white !important">Programme de suivi de cours</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>



<div style="margin-top: 23px;" class="test" #formfollow [hidden]="hide">

    <div class="modal-header border-0">
        <h4 style="font-size: 15px;
        font-weight: bold;" class="modal-title" id="modal-basic-title"> {{item?.id?.substring(6)}}</h4>
        <!-- <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button> -->
    </div>
    <div class="modal-body border-0">

        <div class="col-sms-12" style="text-align:left; font-size:14px">
            <div class="card-body">
                <form [formGroup]="followUpForm" ngNativeValidate (ngSubmit)="validate()">

                    <div class="col-sms-12" style="text-align:left; font-size:14px">

                        <div class="card-body">


                            <div style="margin-bottom: 15px;align-items: normal !important;margin-top:14px">
                                <div *ngIf="(error || message)"
                                    [ngClass]="{'text-danger':error,'text-success':message, 'bg-danger':error,'bg-success':messageForm}"
                                    class="card">
                                    <ul class="list-group list-group-flush ">
                                        <li style="font-size: 13px;" class="list-group-item"
                                            [ngClass]="{'text-danger':error,'text-success':message}">
                                            {{error||message}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="formFile" class="form-label" style="color:#ccc">Date de modification</label>
                                <input name="date" formControlName="date" type="date" placeholder="ex: 06/02/1978"
                                    class="form-control">
                            </div>

                            <div class="mb-3">
                                <label for="formFile" class="form-label" style="color:#ccc">Etape</label>
                                <input name="step" formControlName="step" type="text"
                                    placeholder="ex: slide 6, terminé..." class="form-control">
                            </div>

                            <div class="mb-3">
                                <label for="formFile" class="form-label" style="color:#ccc">Remarques</label>
                                <textarea name="notice" formControlName="notice"
                                    placeholder="ex:Terminé par  C. La Croix du Christ devient un modèle pour ceux qui suivent le Christ "
                                    class="form-control" rows="3" id="comment"></textarea>
                            </div>
                        </div>

                        <button [disabled]="showSpinner" type="submit" style="margin-bottom: 23px;background-color:white!important;margin-top: 23px;
                            color:black;border-width: 3px;font-weight:bold;border-color: #9b215cde;"
                            class="btn btn-success btn-sm">
                            Soumettre
                            <span *ngIf="showSpinner" style="height: 19px;
                            width: 19px;
                            margin-left: 13px;" class="spinner-border spinner"></span>
                        </button>
                    </div>
                </form>

            </div>

        </div>
    </div>
</div>

<div class="container mt-3">
    <div class="row no-gutters align-items-center">
        <div class="col mr-2">
            <div class="card-grid">
                <div class="card" >
                    <div class="card-content">
                        <div class="card-text">
                            <h2>Cours disponibles</h2>
                        </div>
                        <div class="card-image">
                            <img src="assets/img/courses/suivi.svg" alt="image">
                        </div>
                    </div>


                    <div style="cursor:pointer;margin-top:44px" class="scroll d-flex flex-column align-items-stretch">
                        <div *ngFor="let item of items" (click)="updateCourseInfo(item,content)"
                            class="p-2   mb-2 rounded cardsp" >
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="courses-name">{{item?.id}}</div>
                
                                <div class="courses-meta">
                                    <i style="color: #9b215c;font-size: 20px;" class="bx bx-notepad"
                                        aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        
    </div>
  
</div>

<div class="courses-details-area pb-100">

    <div class="container">
  
        <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-8 col-md-12">
                <nav style="margin-top:45px" aria-label="Page navigation example">
                    <ul class="pagination justify-content-end">
                        <li (click)="page(paginations[0])" [ngClass]="{'active':paginations[0].selected}"
                            class="page-item active"><a class="page-link"
                                href="javascript:void(0)">{{paginations[0].number}}</a></li>
                        <li (click)="page(paginations[1])" [ngClass]="{'active':paginations[1].selected}"
                            class="page-item active"><a class="page-link"
                                href="javascript:void(0)">{{paginations[1].number}}</a></li>
                        <li (click)="page(paginations[2])" [ngClass]="{'active':paginations[2].selected}"
                            class="page-item active"><a class="page-link"
                                href="javascript:void(0)">{{paginations[2].number}}</a></li>
                        <li (click)="page(paginations[3])" [ngClass]="{'active':paginations[3].selected}"
                            class="page-item active"><a class="page-link"
                                href="javascript:void(0)">{{paginations[3].number}}</a></li>
                    </ul>
                </nav>
            </div>

        </div>
    </div>
</div>